// Single source of truth for the network roles list.
// Used by Network filter (with "All" prepended), JoinNetwork submission form,
// and AdminProfessionals add/edit form.
export const NETWORK_ROLES = [
  "Director",
  "Writer",
  "Producer",
  "DP",
  "Camera Operator",
  "Editor",
  "Sound",
  "Lighting",
  "Composer",
  "VFX",
  "Colourist",
  "Make-up & Hair",
  "Costume",
  "Production Designer",
  "Set Designer",
  "Casting",
  "Script Supervisor",
  "Location Manager",
  "Location Assistant",
  "Runner",
  "Actor",
];
